import styled from 'styled-components';
export const CountryInfoContainer = styled.div`
    display: flex;
    gap: .5em;
    justify-content: center;
    align-items: center;
    & img{
        width: 16px;
    }

`
export const BrowserContainer = styled.div`
    text-align: left;
`
export const IPText = styled.span`
    ${({ $blocked }) => $blocked && `color: var(--danger-color);`}
`
export const IPContainer = styled.div`
    display: flex;
    gap: .5em;
    margin-bottom: 1em;
    justify-content: space-between;
    align-items: center;
    & svg{
        font-size: 18px;
        cursor: pointer;
    }
    & svg.block-icon{
        color: var(--danger-color);
        &:hover{
            color: rgba(229, 56, 72, .7);
        }
    }
    & svg.unblock-icon{
        color: var(--success-color);
        &:hover{
            color: rgba(23, 173, 64, .7);
        }
    }
    
    & .mb-3{
        margin: 0 !important;
    }

`